import { Component, computed, inject, Injector, Signal } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { LoadingSpinnerComponent } from '@r1-compass-library/components/loading-spinner/loading-spinner.component';
import { LocalStorageService } from '@r1-compass-library/services/local-storage.service';
import { SpinnerService } from '@r1-compass-library/services/spinner.service';
import { filterNil } from 'ngxtension/filter-nil';
import { rxEffect } from 'ngxtension/rx-effect';
import { switchMap, tap, timer } from 'rxjs';
import { handleBrowserStorageAndMakeLogoutRoute } from './app.routes';

@Component({
    selector: 'r1-compass-app-root',
    template: `
        <router-outlet />
        @if (isLoading()) {
            <r1-compass-lib-loading-spinner [loadingMessages]="loadingMessages() ?? []" />
        }
    `,
    imports: [RouterOutlet, LoadingSpinnerComponent],
})
export class AppComponent {
    readonly #router = inject(Router);
    readonly #localStorageService = inject(LocalStorageService);
    readonly #spinnerService = inject(SpinnerService);
    readonly #injector = inject(Injector);

    secondsUntilLogout: Signal<number | undefined> = computed(() => {
        const expiration = this.#localStorageService.jwtClaims()?.expiration;
        return expiration ? expiration - Date.now() : undefined;
    });

    constructor() {
        const _pollOauthExpiration = rxEffect(
            toObservable(this.secondsUntilLogout).pipe(
                filterNil(),
                switchMap(seconds => timer(seconds)),
                tap(() => this.#router.navigateByUrl(handleBrowserStorageAndMakeLogoutRoute(this.#injector)))
            )
        );
    }

    isLoading = toSignal(this.#spinnerService.isLoading());
    loadingMessages = toSignal(this.#spinnerService.getMessages().pipe(filterNil()));
}
